import {Link as RoutedLink} from 'react-router-dom';

import {ButtonGroup} from 'shells/button-group/button-group';
import {ChatbotRegularReportIcon} from 'shells/icon/svg/chatbot-regular-report-icon';
import {CogRegularIcon} from 'shells/icon/svg/cog-regular-icon';
import {Link} from 'shells/link/link';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import {useGetSessionUser} from '../../core/use-get-session-user';

interface Props {
    shouldShowChatbotReportButton?: boolean;
}

export function ChatHeaderButtons(props: Props) {
    const {user} = useGetSessionUser();
    const userCanAccessSetup = Boolean(user && user.permissions.canAccessSetup);
    const shouldShowChatbotReportButton = Boolean(
        props.shouldShowChatbotReportButton && NutClientConfig.hasChatbotReportFF
    );

    if (!userCanAccessSetup && !shouldShowChatbotReportButton) {
        return null;
    }

    return (
        <ButtonGroup>
            {shouldShowChatbotReportButton && (
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    icon={ChatbotRegularReportIcon}
                    to='/reports/chatbot'
                    size='big'
                    variant='button-secondary'
                    onClick={async (e: React.MouseEvent) => {
                        e.preventDefault();
                        await analyticsClient.track(
                            analyticsClient.EVENTS.TRACK_CR_BUTTON_CLICKED_FROM_THREADS_HEADER
                        );
                        appHistory.push('/reports/chatbot');
                    }}
                >
                    Chatbot report
                </Link>
            )}
            {userCanAccessSetup && (
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    icon={CogRegularIcon}
                    to='/inbox/settings/chat'
                    size='big'
                    variant='button-secondary'
                >
                    Chat settings
                </Link>
            )}
        </ButtonGroup>
    );
}
